import { combineReducers } from 'redux';
import { FETCH_VEHICLE_POSITION_STATISTICS, RESET_COMPANY_CONTEXT } from '../../actions';
import { normalizeVehiclePositions } from '../../normalizers';

const positionStatisticsInitState = { data: {}, loading: false, error: null };
function positionStatisticsReducer(state = positionStatisticsInitState, { type, payload, meta }) {
  switch (type) {
    case FETCH_VEHICLE_POSITION_STATISTICS.SUCCESS:
      if (state.actionId !== meta.previousAction.payload.actionId) {
        return state;
      }
      return {
        ...state, data: normalizeVehiclePositions(payload.data), loading: false, error: null,
      };
    case FETCH_VEHICLE_POSITION_STATISTICS.FAIL:
      if (state.actionId !== meta.previousAction.payload.actionId) {
        return state;
      }
      return { ...state, loading: false, error: payload };
    case FETCH_VEHICLE_POSITION_STATISTICS.START:
      return { ...state, loading: true, actionId: payload.actionId };
    case RESET_COMPANY_CONTEXT:
      return { ...positionStatisticsInitState };
    default:
      return state;
  }
}

export default combineReducers({
  statistics: positionStatisticsReducer,
});
